// One type system for the web player and the portal (Sol round6, 2026-10-06; owner: "we need to use consistent [fonts],
// especially when font and sizing difference is huge").
//
// Sizes: the owner's standard (14/16/20/24/32, 12 Oct; Sol web-type-standard A, 15 Oct - the same as the iPhone app):
// every key lands on it - xs and sm 14, base 16, lg and xl 20, 2xl 24, 3xl and up 32; nothing under 14.
// Weights 400/600/700 only. Poppins only for the 32 px titles; everything else Plus Jakarta Sans.
// Families: on web, Poppins for headings and Plus Jakarta Sans for everything else (body, controls, labels), served from
// this app (public/fonts) with system fallbacks. Native keeps its own platform fonts until they are tested separately,
// so on iOS/Android the families resolve to undefined and React Native uses the system font as before.
import { Platform } from 'react-native';

export const TYPE = {
  xs: 14,
  sm: 14,
  base: 16,
  lg: 20,
  xl: 20,
  '2xl': 24,
  '3xl': 32,
  '4xl': 32,
  '5xl': 32,
};

/** The owner's type standard (14/16/20/24/32, round 22): screen titles are 32 px, which the older scale above lacks. */
export const TITLE_SIZE = 32;

export const MIN_FONT_SIZE = TYPE.sm;

/**
 * The one place capitals are allowed (Sol mobile-type-audit D1 B, 15 Oct, for mobile and web): short status and rarity
 * tags - NOW, LIMITED, RECOMMENDED, COMMON/RARE/..., BADGE EARNED. Every title, heading, button, tab and label is in
 * Title Case.
 */
export const TAG = { fontSize: TYPE.sm, fontWeight: '600', letterSpacing: 1, textTransform: 'uppercase' };

const IS_WEB = Platform.OS === 'web';

export const FONTS = {
  heading: IS_WEB ? '"Poppins", "Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", sans-serif' : undefined,
  body: IS_WEB ? '"Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", sans-serif' : undefined,
};
